import { useQuery } from "@tanstack/react-query";
import { GitBranch, Network } from "lucide-react";

import { api } from "@/api/client";
import type { EnvoyEgressIp } from "@/api/types";
import { Pill } from "@/components/Pill";
import { Section } from "@/components/Section";

export function GlobalEgressIps() {
  const ips = useQuery({
    queryKey: ["egress-ips"],
    queryFn: () => api.get<EnvoyEgressIp[]>("/egress-ips"),
  });

  return (
    <Section
      title="Envoy egress IPs"
      icon={<Network />}
      count={`${ips.data?.length ?? 0} addresses`}
      flush
    >
      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th>IP</th>
              <th>CIDR</th>
              <th>Status</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody>
            {(ips.data ?? []).map((ip) => (
              <tr key={ip.id} className="hoverable">
                <td className="mono">{ip.ip}</td>
                <td className="mono muted">{ip.cidr ?? "—"}</td>
                <td>
                  <Pill tone={ip.status === "active" ? "ok" : "warn"}>
                    {ip.status}
                  </Pill>
                </td>
                <td className="muted">{ip.note ?? "—"}</td>
              </tr>
            ))}
            {!ips.data?.length && (
              <tr>
                <td colSpan={4} className="empty">
                  <GitBranch
                    style={{
                      width: 16,
                      height: 16,
                      verticalAlign: "middle",
                      marginRight: 6,
                    }}
                  />
                  no egress IPs registered yet — Cloud NAT outputs will be
                  discovered automatically once the controller starts up
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Section>
  );
}
